import { Profile } from '@/screens/profile';

export default function ProfileScreen() {
  return <Profile />;
}
